/*
 * @Description:
 * @Author: wjx
 * @Date: 2019-04-28 13:17:06
 */
import '@/tools/request';
import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import projectSettled from '@/page/settlementCenter/projectSettled/store.js';
import dataAnalysis from '@/page/project-record/store/task-record/project';
import orderMgmt from '@/page/settlementCenter/orderMgmt/store';

Vue.use(Vuex);
let modules = {};
const storeContext = require.context('@/store/modules', true, /\.js$/);
storeContext.keys().forEach(modulesItem => {
  modules[modulesItem.replace(/(^\.\/)|(\.js$)/g, '')] = storeContext(
    modulesItem
  ).default;
  // store.registerModule(modules.replace(/(^\.\/)|(\.js$)/g, ''), storeContext(modules).default)
});

// const localCache = store => {
//   store.subscribe((mutation, state) => {
//     if (mutation.type === 'SET_HOME_QUERY') {
//       setStorage('user', mutation.payload);
//     }
//   });
// };

const store = new Vuex.Store({
  modules: {
    ...modules,
    projectSettled,
    dataAnalysis,
    orderMgmt
  },
  state: {
    // 是否显示aside与menus
    showMenus: true
  },
  mutations: {
    SET_SHOW_MENUS(state, payload) {
      state.showMenus = payload;
    }
  },
  getters
  // plugins: [localCache]
});

export default store;
